// // AuthContext.js
// import React, { createContext, useState, useEffect, useContext } from 'react';
// import { onAuthStateChanged, signOut } from 'firebase/auth';
// import { ref, get } from 'firebase/database';
// import { auth, db } from './firebase';

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Listen to Firebase auth state changes
//     const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
//       if (firebaseUser) {
//         try {
//           // Check if user is Admin
//           const adminRef = ref(db, `Dr/Admin/${firebaseUser.uid}`);
//           const adminSnapshot = await get(adminRef);

//           if (adminSnapshot.exists()) {
//             const adminData = adminSnapshot.val();
//             setUser({
//               uid: firebaseUser.uid,
//               email: firebaseUser.email,
//               ...adminData,
//               isAdmin: true,
//               role: 'admin'
//             });
//             setLoading(false);
//             return;
//           }

//           // Check if user is regular user/patient
//           const userRef = ref(db, `Dr/users/${firebaseUser.uid}`);
//           const userSnapshot = await get(userRef);

//           if (userSnapshot.exists()) {
//             const userData = userSnapshot.val();
//             setUser({
//               uid: firebaseUser.uid,
//               email: firebaseUser.email,
//               ...userData,
//               isAdmin: false,
//               role: 'user'
//             });
//           } else {
//             // Authenticated but no profile
//             setUser(null);
//           }
//         } catch (error) {
//           console.error('Error fetching user data:', error);
//           setUser(null);
//         }
//       } else {
//         setUser(null);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   const logout = async () => {
//     try {
//       await signOut(auth);
//       setUser(null);
//     } catch (error) {
//       console.error('Logout error:', error);
//       throw error;
//     }
//   };

//   const value = {
//     user,
//     currentUser: user,
//     isAuthenticated: !!user,
//     isAdmin: user?.isAdmin || false,
//     userRole: user?.role || null,
//     loading,
//     logout
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// // Custom hook
// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };



// AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in from sessionStorage (auto-clears on tab/browser close)
    const storedUser = sessionStorage.getItem('user');
    const storedToken = sessionStorage.getItem('token');
    
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    sessionStorage.setItem('user', JSON.stringify(userData));
    sessionStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    // Clear sessionStorage (user session)
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    // Clear all login-related localStorage keys
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
    localStorage.removeItem('guest_cart');
  };

  const isAdmin = () => {
    return user && user.role === 'admin';
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin, loading }}>
      {children}
    </AuthContext.Provider>
  );
};